export enum TranslationType {
    None,
    RoomType,
    BoardType
}
